var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.219 25.372H9.805c-5.517 0-7.195-1.677-7.195-7.194V9.39c0-5.517 1.678-7.195 7.195-7.195h15.4c5.517 0 7.194 1.678 7.194 7.195v8.774c.014 5.531-1.663 7.208-7.18 7.208ZM9.805 4.275c-4.353 0-5.115.762-5.115 5.115v8.774c0 4.353.762 5.115 5.115 5.115h15.4c4.353 0 5.115-.762 5.115-5.115V9.39c0-4.353-.762-5.115-5.115-5.115h-15.4Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.512 31.998a1.046 1.046 0 0 1-1.04-1.04v-6.625a1.046 1.046 0 0 1 1.04-1.04 1.046 1.046 0 0 1 1.04 1.04v6.626a1.046 1.046 0 0 1-1.04 1.04Z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.374 19.523H3.65a1.046 1.046 0 0 1-1.04-1.04 1.046 1.046 0 0 1 1.04-1.04h27.724a1.046 1.046 0 0 1 1.04 1.04 1.046 1.046 0 0 1-1.04 1.04Z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 32H11.274a1.046 1.046 0 0 1-1.04-1.04 1.047 1.047 0 0 1 1.04-1.04H23.75a1.047 1.047 0 0 1 1.04 1.04A1.047 1.047 0 0 1 23.75 32Z",
    fill: "url(#d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 27.221,
    y1: 4.012,
    x2: 13.286,
    y2: 25.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 18.191,
    y1: 23.976,
    x2: 15.08,
    y2: 24.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 27.232,
    y1: 17.606,
    x2: 27.075,
    y2: 20.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 22.259,
    y1: 30.083,
    x2: 21.941,
    y2: 32.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechCard);
export default __webpack_public_path__ + "static/media/TechCard.bab970e0accd5492b346668a92dc0f98.svg";
export { ForwardRef as ReactComponent };